import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from '@/components/design-system/tooltip';
import { cn } from '@/utils/cn';

export const TooltipWrapper = ({
  trigger,
  content,
  className,
  delayDuration,
  side = 'top',
  variant = 'default'
}: {
  trigger: React.ReactNode;
  content: React.ReactNode;
  className?: string;
  delayDuration?: number;
  side?: 'top' | 'right' | 'bottom' | 'left';
  variant?: 'default' | 'error';
}) => {
  const variantClasses = {
    default: '',
    error: 'bg-error-500 text-white'
  };

  const arrowClasses = {
    default: 'fill-primary',
    error: 'fill-error-500'
  };

  return (
    <TooltipProvider delayDuration={delayDuration}>
      <Tooltip>
        <TooltipTrigger asChild>{trigger}</TooltipTrigger>
        <TooltipContent side={side} className={cn(variantClasses[variant], className)}>
          {content}
          <TooltipArrow className={arrowClasses[variant]} />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
